import { Box, Typography, Paper, Button } from "@mui/material";
import LoginFooter from "./LoginFooter";
import { LoginHeader } from "./LoginHeader";
import { useEffect, useState } from "react";
// import { useMsal } from "@azure/msal-react";
import loginImage from "../../assets/images/login-image.png";
import { RouterPathEnum } from "../../constants/router";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
  const navigate = useNavigate();
  // const { instance } = useMsal();
  const [contentHeight, setContentHeight] = useState<number>(0);

  const handleSetContentHeight = () => {
    const headerHeight =
      document.getElementById("loginHeader")?.offsetHeight || 0;
    const footerHeight =
      document.getElementById("loginFooterContainer")?.offsetHeight || 0;
    const totalHeight = window.innerHeight - headerHeight - footerHeight;
    setContentHeight(totalHeight);
  };

  useEffect(() => {
    handleSetContentHeight();
    window.addEventListener("resize", handleSetContentHeight);
    return () => window.removeEventListener("resize", handleSetContentHeight);
  }, []);

  const handleAccessRedirect = async () => {
    try {
      navigate(`/${RouterPathEnum.DGO}/${RouterPathEnum.DASHBOARD}`);
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <Box
      id="loginMainContainer"
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "#f4f6f8",
      }}
    >
      <Box id="loginHeader">
        <LoginHeader />
      </Box>

      <Box
        sx={{
          height: contentHeight,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
        }}
      >
        <Paper elevation={3} sx={{ p: 4, maxWidth: 1000, width: "100%" }}>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box
              component="img"
              src={loginImage}
              alt="Login"
              sx={{
                width: "120px",
                height: "auto",
                objectFit: "cover",
                alignSelf: "flex-start",
                mb: 2,
              }}
            />

            <Typography variant="h4" color="error" gutterBottom align="center">
              Access Denied
            </Typography>
          </Box>

          <Typography variant="body1" sx={{ mb: 2 }} align="center">
            Oops! It looks like you don't have access to this section.
          </Typography>

          <Box display="flex" justifyContent="center">
            <Box style={{ padding: "5px", textAlign: "center" }}>
              <Button onClick={handleAccessRedirect} variant="contained">
                Go Back to Dashboard
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>

      <Box id="loginFooterContainer">
        <LoginFooter />
      </Box>
    </Box>
  );
};

export default AccessDenied;
